import { apolloProvider } from '@/modules/GraphQL';
import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { INCREMENT_LESSON_HABIT, INCREMENT_LESSON_HABIT_MSB } from '@/graphql/mutations/lessonHabit';
import logger from '@/modules/Logger';

export const IncrementLessonHabitService = {
  msb: async (successCallback, errorCallback) => {
    logger.debug(`[IncrementLessonHabit] Increment lesson habit using MSB GraphQL endpoint`, {
      operation: 'increment-lesson-habit'
    });

    const client = myStageApolloProvider.defaultClient;
    client.mutate({
        mutation: INCREMENT_LESSON_HABIT_MSB,
        fetchPolicy: 'no-cache'
    })
    .then(successCallback)
    .catch((error) => {
        logger.error(`[IncrementLessonHabit] Error increment lesson habit using MSB GraphQL endpoint`, {
        operation: 'increment-lesson-habit',
          error: error.message
        });

        errorCallback(error);
    })
  },

  mbti: async (successCallback, errorCallback) => {
    logger.debug(`[IncrementLessonHabit] Increment lesson habit using MBTI GraphQL endpoint`, {
      operation: 'increment-lesson-habit'
    });

    const client = apolloProvider.defaultClient;
    client.mutate({
        mutation: INCREMENT_LESSON_HABIT,
        fetchPolicy: 'no-cache'
    })
    .then(successCallback)
    .catch((error) => {
        logger.error(`[IncrementLessonHabit] Error increment lesson habit using MBTI GraphQL endpoint`, {
        operation: 'increment-lesson-habit',
          error: error.message
        });

        errorCallback(error);
    })
  },
};

// Route legacy endpoint to MBTI, because this API does not have FuelPHP version
IncrementLessonHabitService.legacy = IncrementLessonHabitService.mbti;
